import { fbt } from 'fbtee'
import type { ProfileStat } from '../../components/profile/buildProfileStats'

/** The counts beside a group's photo: members, upcoming plans, past events. */
export function buildGroupStats({
  memberCount,
  upcomingCount,
  pastCount,
}: {
  memberCount: number
  upcomingCount: number
  pastCount: number
}): ProfileStat[] {
  return [
    {
      key: 'members',
      value: memberCount,
      label: fbt(fbt.plural('member', memberCount, { many: 'members' }), 'Group page header stat label under the number of members'),
    },
    {
      key: 'plans',
      value: upcomingCount,
      label: fbt(fbt.plural('plan', upcomingCount, { many: 'plans' }), 'Group page header stat label under the number of upcoming events linked to the group'),
    },
    {
      key: 'past',
      value: pastCount,
      label: fbt('past', 'Group page header stat label under the number of past events linked to the group'),
    },
  ]
}
